export const BASE_URL = '/app/i-was-here';
